import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";

const Battery_report_entry = () => {
  useAuthRedirect();

  const navigate = useNavigate();
  const {id} = useParams();

  const [formData, setFormData] = useState({
    removedDate: "",
    removedKm: "",
    reason: "",
    remarks: "",
  });

           const canEntry = hasPermission("Battery Card Maintenance", "entry");

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.removedDate.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Select Removed Date!',
          });
          return;
        }

         if (!formData.removedKm.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Removed KM/Hr!',
          });
          return;
        }

         if (!formData.reason.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Removed Reason!',
          });
          return;
        }

    const payload = {
        removedDate: formData.removedDate,
        removedKm: formData.removedKm,
        reason: formData.reason,
        remarks: formData.remarks,
    };

    console.log("Submitting Payload:", payload);

    try {

         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                  });

      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/battery_report/${id}`,payload);

      console.log(response);

      Swal.fire({
        title: "Success!",
        text: "Battery Card Report added successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true,
      }).then(() => {
        navigate(
          `/battery_transaction_view`
        );
      });
    // alert("Success");
    } catch (error) {
      console.error("Error submitting form:", error);
        Swal.fire({
                      icon: "error",
                      title: "Insert Failed",
                      text: "Submission failed. Please try again.",
                    });
    }
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Batterycard Report</h2>
          <Link to='/battery_transaction_view'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}> 
            <div className="form-row">
            <div className="form-group">
                <label>Removed Date :</label>
                <input type="date" name="removedDate" value={formData.removedDate} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>Removed Km/Hr :</label>
                <input type="text" name="removedKm" value={formData.removedKm} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Reason :</label>
                <textarea  name="reason" value={formData.reason} onChange={handleChange} style={{ width: "285px" }}/>
              </div>

              <div className="form-group">
                <label>Remark :</label>
                <textarea name="remarks" value={formData.remarks || ""} onChange={handleChange} style={{ width: "285px" }} />

              </div>
            </div>

            

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Battery_report_entry;
